<template>
    <section class="">
        <div class="py-12 section-gallery lg:py-20 max-w-5xl mx-auto rounded-lg" style="background-color: #D7DCE8;">
            <div class="mx-auto max-w-[1140px]">
                <h2 class="mb-10 font-bold text-center text-4xl font-ww-bold" v-html="title">
                </h2>

                <div class="gallery-canvas rounded-lg md:px-16 px-8">
                    <div class="grid grid-cols-1 gap-6 md:grid-cols-2 md:gap-6">
                        <!-- Post 1: Full width on mobile/tablet, spans 2 cols on desktop -->
                        <div class="md:col-span-2">
                            <nuxt-img :src="images[0].src" :alt="images[0].alt" width="847" height="543"
                                class="w-full h-auto transition-transform duration-300 rounded" loading="lazy"
                                sizes="100vw sm:100vw md:100vw lg:850px" format="webp" />
                        </div>

                        <!-- Row 2: Two posts side-by-side -->
                        <div class="flex flex-col">
                            <nuxt-img :src="images[1].src" :alt="images[1].alt" width="426" height="314"
                                class="w-full h-auto rounded max-h-80  transition-transform duration-300" loading="lazy"
                                sizes="100vw sm:100vw md:50vw lg:430px" format="webp" />
                        </div>
                        <div class="flex flex-col">
                            <nuxt-img :src="images[2].src" :alt="images[2].alt" width="397" height="313"
                                class="w-full rounded max-h-80 transition-transform duration-300 h-full object-cover object-top"
                                loading="lazy" sizes="100vw sm:100vw md:50vw lg:400px" format="webp" />
                        </div>


                    </div>

                    <div class="grid grid-cols-12 md:gap-x-8 mt-6 md:mt-8 gap-y-6 md:gap-y-8">
                        <!-- Row 3: Complex layout - Tall on left, two stacked on right -->
                        <div class="flex md:col-span-8 col-span-12">
                            <nuxt-img :src="images[3].src" :alt="images[3].alt" width="540" height="444"
                                class="w-full h-full object-cover rounded  transition-transform duration-300"
                                loading="lazy" sizes="100vw sm:100vw md:67vw lg:540px" format="webp" />
                        </div>

                        <div class="flex flex-col md:col-span-4 col-span-12 gap-6 md:gap-6">
                            <nuxt-img :src="images[4].src" :alt="images[4].alt" width="276" height="189"
                                class="w-full flex-1 object-cover object-right rounded  transition-transform duration-300"
                                loading="lazy" sizes="100vw sm:100vw md:33vw lg:280px" format="webp" />
                            <nuxt-img :src="images[5].src" :alt="images[5].alt" width="276" height="224"
                                class="w-full flex-1 object-cover rounded  transition-transform duration-300"
                                loading="lazy" sizes="100vw sm:100vw md:33vw lg:280px" format="webp" />
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </section>
</template>

<script setup>
const props = defineProps({
    title: {
        type: String,
        default: 'Top Creators LOVE Lifeboost!!'
    },
    images: {
        type: Array,
        default: () => [
            { src: '/assets/images/creator-bogo-new-4.jpg', alt: 'Creator review 1' },
            { src: '/assets/images/creators-bogo-1.jpg', alt: 'Creator review 2' },
            { src: '/assets/images/creator-bogo-new-3.png', alt: 'Creator review 3' },
            { src: '/assets/images/creator-bogo-new-2.jpg', alt: 'Creator review 4' },
            { src: '/assets/images/creators-bogo-4.jpg', alt: 'Creator review 5' },
            { src: '/assets/images/creator-bogo-new-1.jpg', alt: 'Creator review 6' }
        ]
    }
});

defineBuilderComponent({
    friendlyName: 'Title Image Gallery',
    inputs: [
        {
            name: 'title',
            type: 'richText',
            defaultValue: 'Top Creators LOVE Lifeboost!!'
        },
        {
            name: 'images',
            type: 'list',
            subFields: [
                {
                    name: 'src',
                    type: 'file',
                    allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp']
                },
                {
                    name: 'alt',
                    type: 'text'
                }
            ],
            defaultValue: [
                { src: '/assets/images/creator-bogo-new-4.jpg', alt: 'Creator review 1' },
                { src: '/assets/images/creators-bogo-1.jpg', alt: 'Creator review 2' },
                { src: '/assets/images/creator-bogo-new-3.png', alt: 'Creator review 3' },
                { src: '/assets/images/creator-bogo-new-2.jpg', alt: 'Creator review 4' },
                { src: '/assets/images/creators-bogo-4.jpg', alt: 'Creator review 5' },
                { src: '/assets/images/creator-bogo-new-1.jpg', alt: 'Creator review 6' }
            ]
        }
    ]
});
</script>